import React, { Component, Fragment } from 'react';
import Header from './Header';
import CSVGenerator from '../utils/json2csv';
import _ from 'lodash';
import moment from 'moment';
import Table from './Table';
import { getPaymentStatus, uploadPaymentStatus } from '../utils/PaymentRequestApiUtils';
import { TextField, Button, Snackbar, LinearProgress,
    Dialog, DialogContent, DialogActions, DialogTitle
} from '@material-ui/core';
import userdata from '../config/jwt_token'
const keys = require('../config/keys');
const constants = require('../config/constants');

const COLUMNS = [
    {
        Header: 'PR Index',
        key: 'payment_request_id'
    },
    {
        Header: 'Upload Date',
        key: 'transaction_date'
    },
    {
        Header: 'RSN',
        key: 'buf_id'
    },
    {
        Header: 'Requestor',
        key: 'requestor_name'
    },
    {
        Header: 'Approver',
        key: 'approver_name'
    },
    {
        Header: 'Zolo Property Name',
        key: 'cost_center'
    },
    {
        Header: 'Vendor Code',
        key: 'vendor_code'
    },
    {
        Header: 'Vendor Name',
        key: 'vendor_name'
    },
    {
        Header: 'Vendor GSTN',
        key: 'vendor_gstn'
    },
    {
        Header: 'Payment Code',
        key: 'payment_request_code'
    },
    {
        Header: 'Expenditure-Category',
        key: 'ledger_name'
    },
    {
        Header: 'Description',
        key: 'narration'
    },
    //Category
    {
        Header: 'Entity',
        key: 'type'
    },
    {
        Header: 'Invoice (Without GST) Amount',
        key: 'total_invoice_amount'
    },
    {
        Header: 'GST',
        key: 'gst_total'
    },
    {
        Header: 'Invoice Amount',
        key: 'invoice_amount_with_gst'
    },
    {
        Header: 'TDS',
        key: 'total_tds_deduction'
    },
    {
        Header: 'Other Deductions',
        key: 'total_deduction_others'
    },
    {
        Header: 'Advance Paid',
        key: 'advance_paid'
    },
    {
        Header: 'Net Payment',
        key: 'total_payable_amount'
    },
    {
        Header: 'Total PO Amount',
        key: 'full_invoice_amount_display'
    },
    {
        Header: 'Section',
        key: 'it_section_applicable'
    },
    {
        Header: 'City',
        key: 'city'
    },
    {
        Header: 'Tally Narration',
        key: 'tally_narration'
    }, 
    {
        Header: 'Bene A/c No.',
        key: 'bank_acc_number'
    },
    {
        Header: 'Bene Name',
        key: 'beneficiary_name'
    },
    {
        Header: 'Customer Ref No',
        key: 'cust_ref_number'
    },
    {
        Header: 'IFSC code',
        key: 'ifsc_code'
    },
    {
        Header: 'Bene Bank Name',
        key: 'bank_name'
    },
    {
        Header: 'TXN ID',
        key: 'transaction_id'
    },
    {
        Header: 'TXN Date',
        key: 'transaction_date'
    },
    {
        Header: 'Status',
        key: 'transaction_status'
    },
    {
        Header: 'Attachment',
        key: 'invoice_soft_copy_link'
    },
    {
        Header: 'Supporting Document',
        key: 'supporting_document_link'
    },
    {
        Header: 'Property Code',
        key: 'zolo_code'
    },
    {
        Header: 'Invoice/PO No.',
        key: 'invoice_or_po'
    },
    {
        Header: 'Invoice Date',
        key: 'date_of_invoice'
    },
    {
        Header: 'EXP FTM',
        key: 'expenditure_month'
    },
    {
        Header: 'Recoverable',
        key: 'is_recoverable'
    },
    {
        Header: 'Amount Recoverable',
        key: 'amount_recoverable'
    }
]

const PAYMENT_STATUS_FILE_TEMPLATE_URL = 'https://docs.google.com/spreadsheets/d/1StgY54fuBytcXiSCyRgvQLiz0MEURFp-KilqQ5vQOQM/edit#gid=2027555620';

class PaymentStatus extends Component{
    constructor(){
        super();
        this.state = {
            data: [],
            fromDate: '',
            toDate: '',
            fromDateShow: '',
            toDateShow: '',
            selectedFile: null,
            selectedFileName: "",
            fromDateErr: false,
            fromDateErrText: '',
            toDateErr: false,
            toDateErrText: '',
            fileError: false,
            fileErrorText: "",
            inProgress: false,
            snackMessage: "",
            snackOpen: false,
            validationsDialogOpen: false,
            validationErrors: [],
            dialogOpen: false,
            dialogBoxText: "",
            showUploadButton: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.submitFilter = this.submitFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.generateCSV = this.generateCSV.bind(this);
        this.uploadStatus = this.uploadStatus.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleValidationsDialogClose = this.handleValidationsDialogClose.bind(this);
        this.handleCloseSnack = this.handleCloseSnack.bind(this);
        this.handleFetchData = this.handleFetchData.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
    }

    componentWillMount(){
        if (userdata) {
            let role = userdata.role
            if(role !== 'City Finance' && role !== 'City Head')
                this.setState({showUploadButton: true})
        }
    }
    componentDidMount(){
        this.handleFetchData()
    }

    handleChange = (props) => (event, index, value) => {
        this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
    }

    handleFileChange = (event) => {
        let file = event.target.files[0];
        if(file.type === "text/csv" || file.type === "application/octet-stream" || file.type === "application/vnd.ms-excel"){
            this.setState({ selectedFile: file, selectedFileName: file.name })
            return
        }
        else{
            this.setState({ snackOpen: true, snackMessage: 'Only Csv files are allowed.' })
            return
        }
    }

    async submitFilter() {

        if (this.state.toDateShow !== '' && this.state.toDateShow < this.state.fromDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' })
            return
        }
        
        if (this.state.fromDateShow !== '' && this.state.fromDateShow > this.state.toDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'To date should be greater than From date' })
            return
        }
        this.setState({fromDate: this.state.fromDateShow, toDate: this.state.toDateShow}, () =>
            this.handleFetchData({from_date: this.state.fromDate, to_date: this.state.toDate})
        )
        
    }

    handleFetchData(filters = {}){
        this.setState({ inProgress: true },() => {
            getPaymentStatus(filters).then(response => {
                if (response) {
                    if (response.status === 'success') {
                        let data = response.data.map(data => {
                            return {
                                ...data,
                                instruction_date: moment(data.instruction_date).format('DD-MM-YYYY'),
                                transaction_date: (data.transaction_date)?moment(data.transaction_date)
                                  .format('DD-MM-YYYY'):data.transaction_date,
                                cost_center: (data.total_cost_centers>1)?'Multi Cost centers':data.cost_center,
                                beneficiary_email_id: 'finance@zolostays.com',
                                full_invoice_amount_display: (data.partial_payment_percentage && data.full_invoice_amount) ? data.full_invoice_amount : '-'
                            }
                        })
                        this.setState({data, inProgress: false})
                    }
                    else {
                        this.setState({snackMessage: response.message, snackOpen: true, inProgress: false})
                    }
                }
            }).catch(error => {
                this.setState({snackMessage: error.message, snackOpen: true, inProgress: false})
            })
        })
    }

    uploadStatus = async () => {
        if(this.state.selectedFile !== null){
            this.setState({ dialogOpen: false, dialogBoxText: "", inProgress: true },()=>{
                let formData = new FormData()
                formData.append('upload', this.state.selectedFile)
                uploadPaymentStatus( formData ).then(response => {
                    if (response) {
                        if (response.status) {
                            setTimeout(()=>{
                                window.location.reload();
                            },3000)
                            this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                        }
                        else if(response.invalidData){
                            this.setState({ validationsDialogOpen: true, validationErrors: response.errors, inProgress: false })
                        }
                        else{
                            this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                        }
                    }
                })
            })
        }
        else{
            this.setState({ snackMessage: "Please select a file to upload.", snackOpen: true })
        }
    }

    handleClose() {
        this.setState({ dialogOpen: false, dialogBoxText: "" })
    }

    handleValidationsDialogClose(){
        this.setState({ validationsDialogOpen: false })
    }

    handleCloseSnack() {
        this.setState({ snackOpen: false })
    }
    
    clearFilter() {
        this.setState({ fromDate: '', toDate: '', fromDateShow: '', toDateShow: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
        this.handleFetchData();
    }

    getCSVData() {
        let urlRegxp = constants.urlRegxp;
        let emptyRegxp = constants.emptyRegxp;
        let data = this.state.data.map((cur)=>({
            'PR Index': cur.payment_request_id,
            'Upload Date': cur.transaction_date,
            'RSN': cur.buf_id,
            'Requestor': cur.requestor_name,
            'Approver': cur.approver_name,
            'Zolo Property Name': cur.cost_center,
            'Vendor Code': cur.vendor_code,
            'Vendor Name': cur.vendor_name,
            'Vendor GSTN': cur.vendor_gstn,
            'Payment Code': cur.payment_request_code,
            'Expenditure-Category': cur.ledger_name,
            'Description': cur.narration,
            'Entity': cur.type,
            'Invoice (Without GST) Amount': cur.total_invoice_amount,
            'GST': cur.gst_total,
            'Invoice Amount': cur.invoice_amount_with_gst,
            'TDS': cur.total_tds_deduction,
            'Other Deductions': cur.total_deduction_others,
            'Advance Paid': cur.advance_paid,
            'Net Payment': cur.total_payable_amount,
            'Section': cur.it_section_applicable,
            'City': cur.city,
            'Tally Narration': cur.tally_narration,
            'Bene A/c No.': cur.bank_acc_number,
            'Bene Name': cur.beneficiary_name,
            'Customer Ref No': cur.cust_ref_number,
            'IFSC code': cur.ifsc_code,
            'Bene Bank Name': cur.bank_name,
            'TXN ID': cur.transaction_id,
            'TXN Date': cur.transaction_date,
            'Status': cur.transaction_status,
            'Attachment': urlRegxp.test(cur.invoice_soft_copy_link) || emptyRegxp.test(cur.invoice_soft_copy_link) || cur.invoice_soft_copy_link === null ? cur.invoice_soft_copy_link : keys.s3.fileLink+cur.invoice_soft_copy_link,
            'Supporting Document': urlRegxp.test(cur.supporting_document_link) || emptyRegxp.test(cur.supporting_document_link) || cur.supporting_document_link === null ? cur.supporting_document_link : keys.s3.fileLink+cur.supporting_document_link,
            'Property Code': cur.zolo_code,
            'Invoice/PO No.': cur.invoice_or_po,
            'Invoice Date': cur.date_of_invoice,
            'EXP FTM': cur.expenditure_month,
            'Recoverable': cur.is_recoverable,
            'Amount Recoverable': cur.amount_recoverable,
        }))
        let headers = _.map(COLUMNS,'Header');
    
        return {
          data: data,
          headers: headers,
          filename: 'ZAPS_Payment_Status_Upload'
        }
    }

    generateCSV() {
        let csvData = this.getCSVData()
        CSVGenerator(csvData.headers, csvData.data, csvData.filename)
    }

    render(){
        return(
            <Fragment>
                <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Payment Status</h2>
              <p className="zaps-page-subtitle">View and track payment processing status</p>
            </div>
          </div>
                <h4 style={{textAlign: 'center'}}>Details showing from {this.state.fromDate && this.state.toDate?this.state.fromDate:moment().startOf('month').format("YYYY-MM-DD")} to {this.state.toDate && this.state.fromDate?this.state.toDate:moment().endOf('month').format("YYYY-MM-DD")}</h4>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div>
                    Select Transaction Date Range:&nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="date"
                        label="From Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.fromDateShow}
                        onChange={this.handleChange('fromDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.fromDateErr}
                        helperText={this.state.fromDateErrText}
                        margin='normal'
                    />
                    <TextField
                        id="date"
                        label="To Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.toDateShow}
                        onChange={this.handleChange('toDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.toDateErr}
                        helperText={this.state.toDateErrText}
                        margin='normal'
                    />
                    </div>
                    <div>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' || this.state.toDateShow === ''} onClick={this.submitFilter.bind(this)}
                        style={{ marginRight: '20px', marginTop: '25px' }}>
                        Submit Filter
                        </Button>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' && this.state.toDateShow === ''} onClick={this.clearFilter.bind(this)}
                        style={{ background: 'red', marginTop: '25px' }}>
                        Clear Filter
                        </Button>
                    </div>
                </div>
                <div style={{ marginTop: '25px' }} >
                    <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateCSV.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download CSV
                    </Button>
                    {this.state.showUploadButton && <Button variant="contained" size="large" color="primary" onClick={()=>this.setState({ selectedFile: null, selectedFileName: "", dialogOpen: true })} >
                        Upload Status
                    </Button>}
                </div>
                </div>
                <Table columns={COLUMNS} data={this.state.data} />

                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <div >
                        <TextField
                            label=" Upload CSV"
                            value={this.state.selectedFileName}
                            disabled={true}
                            margin='normal'
                            InputLabelProps = {{
                                shrink: true
                            }}
                            style={{ width: '250px' }}
                            error={this.state.fileError}
                            helperText={this.state.fileErrorText}

                        />
                        <label for={'file-upload'} class='custom-file-upload' style={{ border: '1px solid #ccc', display: 'inline-block', padding: '9px 12px', cursor: 'pointer', height: '16px', marginLeft: '5px' }}>
                            Browse
                        </label>
                        <input id={'file-upload'} type="file" onClick={(event) => event.target.value = null} onChange={this.handleFileChange} style={{ display: "none" }} accept="text/csv, application/octet-stream, application/vnd.ms-excel" />
    </div>
                    </DialogContent>
                    <DialogActions style={{justifyItems: 'center'}}>
                        <Button variant="contained" href={PAYMENT_STATUS_FILE_TEMPLATE_URL} size="small" target="_blank" color="primary">
                            Download Template
                        </Button>
                        <Button onClick={this.handleClose} color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={this.uploadStatus} color="primary" autoFocus>
                            Upload
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.validationsDialogOpen}
                    onClose={this.handleValidationsDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                <DialogTitle>
                    There are errors in the file you are trying to upload.
                </DialogTitle>
                    <DialogContent>
                        <ol>
                        {
                            this.state.validationErrors.map(error => {
                                return <li style={{ color: 'red' }}>{error}</li>
                            })
                        }
                        </ol>
                    </DialogContent>
                    <DialogActions style={{justifyItems: 'center'}}>
                        <Button onClick={this.handleValidationsDialogClose} color="primary" autoFocus>
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Progress Dialog */}
                <Dialog
                open={this.state.inProgress}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        Processing...
                        <br/><br/>
                        <LinearProgress />
                    </DialogContent>
                </Dialog>

                <Snackbar
                open={this.state.snackOpen}
                message={this.state.snackMessage}
                autoHideDuration={2500}
                onClose={this.handleCloseSnack.bind(this)}
                />
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
        )
    }
}

export default PaymentStatus;


// WEBPACK FOOTER //
// ./src/components/PaymentStatus.js